export const AUTH_ERROR_CODES = {
  API_KEY_REQUIRED: "AUTH000",
  API_KEY_EXPIRED: "AUTH001",
  INVALID_API_KEY: "AUTH002",
  USER_IS_BLOCKED: "AUTH003",
  FIRST_NAME_REQUIRED: "AUTH004",
  LAST_NAME_REQUIRED: "AUTH005",
  EMAIL_REQUIRED: "AUTH006",
  PHONE_REQUIRED: "AUTH007",
  INVALID_EMAIL: "AUTH008",
  INVALID_PHONE: "AUTH009",
  INVALID_REQUEST: "AUTH010",
  AGENT_ARCHIVED: "AUTH011",
  EMAIL_PHONE_MISMATCH: "AUTH012",
  PASSWORD_REQUIRED: "AUTH013",
  INVALID_CREDENTIALS: "AUTH014",
  UNKNOWN_ERROR: "AUTH015",
  TOKEN_PASSWORD_REQUIRED: "AUTH016",
  PASSWORD_TOO_SHORT: "AUTH017",
  INVALID_TOKEN: "AUTH018",
  INVALID_CAPTCHA: "INVCAP00"
};
